import type { AddressOrNative } from '@cronos-app/sdk';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { RefetchInterval } from '@ui/config/ui';
import { useSDK } from '@ui/utils';
import type { Fraction } from 'bi-fraction';

export const useBondingCurveExpectedReceiveAmountForBuy = ({
  amount,
  tokenAddress,
  ...props
}: {
  amount: Fraction;
  tokenAddress: AddressOrNative;
} & UseQueryOptions<Fraction>) => {
  const sdk = useSDK();

  return useQuery({
    queryKey: [
      'useBondingCurveExpectedReceiveAmountForBuy',
      sdk,
      amount,
      tokenAddress,
    ],
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return sdk
        .getBondingCurveModule()
        .getExpectedReceiveAmountForBuy(amount, tokenAddress);
    },
    refetchInterval: RefetchInterval.Normal,
    ...props,
    enabled: props.enabled !== false && !!sdk,
  });
};

export const useBondingCurveExpectedReceiveAmountForSell = ({
  amount,
  tokenAddress,
  ...props
}: {
  amount: Fraction;
  tokenAddress: AddressOrNative;
} & UseQueryOptions<Fraction>) => {
  const sdk = useSDK();

  return useQuery({
    queryKey: [
      'useBondingCurveExpectedReceiveAmountForSell',
      sdk,
      amount,
      tokenAddress,
    ],
    queryFn: async () => {
      return sdk
        .getBondingCurveModule()
        .getExpectedReceiveAmountForSell(amount, tokenAddress);
    },
    refetchInterval: RefetchInterval.Normal,
    ...props,
    enabled: props.enabled !== false && !!sdk,
  });
};
